import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

export default function Home() {
  const linkedin = <FontAwesomeIcon icon={faLinkedinIn} />;
  const github = <FontAwesomeIcon icon={faGithub} />;

  return (
    <div id="home">
      <div className="container">
        <div className="item box-1">
          <p className="item">Hi!</p>
          <p className="item">I'm Irina Gastmaier</p>
          <p className="item">Full Stack Web Developer</p>
          <p className="item">Based in Berlin</p>
        </div>
        <div className="main-content">
          <div className="main icons">
            <a
              className="linkicon"
              href={'https://github.com/irinagastmaier'}
              title="/irinagastmaier"
              alt="GitHub"
              target="_blank"
              rel="noopener noreferrer"
            >
              {github}
            </a>

            <a
              className="linkicon"
              href={'https://www.linkedin.com/in/irinagastmaier/'}
              title="in/irinagastmaier"
              alt="linkedin"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkedin}
            </a>
          </div>
        </div>
        <div className="triangle"></div>
      </div>
    </div>
  );
}
